module.exports = __webpack_public_path__ + "media/images/icon_list/pin_pinned_postcard-0ceb6f4246288cad08f1d39c9a3ef1d7.svg";